import React from 'react';
import ImageUploader from './ImageUploader';
import LocationMap from './LocationMap';
import spinner from '../images/spinner.gif';
import '../App.css';

export default class PostEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      postTitle: this.props.title,
      postBody: this.props.body,
      imageFile: this.props.imageFile,
      category: this.props.category,
      analyzeResults: ''
    };
  }

  isDev() {
    return window.location.href.indexOf('localhost') !== -1;
  }

  DataURIToBlob(dataURI) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    let vidmimetype = 'video/mp4';
    if (this.isDev()) {
      vidmimetype = 'video/webm';
    }
    const mimetype = this.state.imageFile ? vidmimetype : mimeString;
    return new Blob([ia], { type: mimetype })
  }

  componentWillMount() {
    // Fetch PostCategories
    let url = window.location.protocol + '//' + window.location.host;
    let that = this;
    if (this.props.poll_options) {
      for (let i = 0; i < this.props.poll_options.length; i++) {
        this.setPollOption(i, this.props.poll_options[i].label);
      }
    }
    fetch(`/api/v1/posts/categories`).then(d => {
      d.json().then(data => {
        let categories = data['categories'];
        let catOptions = [];
        for (let i = 0; i < categories.length; i++) {
          catOptions.push(categories[i]);
        }
        that.setState({categories: catOptions});
      });
    });
  }

  updatePostTitle(data) {
    this.setState({postTitle: data});
  }

  updatePostBody(data) {
    this.setState({postBody: data});
  }

  setCategory(event, cat) {
    this.setState({category: cat});
  }

  setPollOption(num, val) {
    let stateUpdate = {};
    stateUpdate['pollOption' + num] = val;
    this.setState(stateUpdate);
  }

  showBody() {
    if (!this.state.childVisible || this.state.childVisible === false) {
      this.setState({
        placeHolder: 'Titulo',
        childVisible: true,
      });
    }
  }

  showImageUploader(event) {
    event.preventDefault();
    this.setState({showImageUploader: true});
  }

  hideImageUploader() {
    this.setState({showImageUploader: false});
  }

  async analyzePost(e) {
    e.preventDefault();
    const fd = new FormData();
    fd.append('body', this.state.postBody);
    const result = await fetch('/api/v1/analyzer', {method: 'POST', body: fd});
    const d = await result.json();
    if (d['results'] && d['results']['objectivity']) {
      if (d['results']['objectivity'] > 70) {
        this.setState({analyzeResults: [`Objetividade: ${d['results']['objectivity']}%`, '#3040f0']});
      } else {
        this.setState({analyzeResults: [`Objetividade: ${d['results']['objectivity']}%`, '#f04030']});
      }
    } else {
      this.setState({analyzeResults: [`Hrmm. Talvez você pudesse expressar isso de forma mais clara.`, '#f09920']});
    }
  }

  async submitPost(e) {
    e.preventDefault();
    if (this.props.messageCreator) {
      this.props.messageCreator.setState({showPostEditor: false});
    }
    let title = this.state.postTitle || '';
    let body = this.state.postBody || '';
    let url = window.location.protocol + '//' + window.location.host;
    url = `${url}/api/v1/posts`;
    if (this.props.title) {
      url += `/${this.props.postId}`;
    }
    let reqData = {
      uri: url,
      method: this.props.title ? 'PUT' : 'POST'
    };
    let that = this;
    let pollOptions = [];
    // Poll options...
    for (let i = 0; i < 5; i++) {
      if (this.state['pollOption' + i]) {
        pollOptions.push(this.state['pollOption' +i]);
      }
    }
    let imageUploader = this._imageUploader || this.imageUploader;
    let category = this.state.category || this.props.app.state.category || 'Geral';
    let loc = this.state.loc?.loc || '';
    let convoId = this.props.conversationId || '';
    let formData = new FormData();
    formData.append('post[title]', title);
    formData.append('post[text]', body);
    formData.append('post[post_category]', category);
    if (convoId) {
      formData.append('post[conversation_id]', convoId);
    }
    if (imageUploader && imageUploader.state && imageUploader.state.binFile && imageUploader.state.binFile.toDataURL) {
      let uploadedStringImage = imageUploader.state.binFile.toDataURL();
      const imgBlob = this.DataURIToBlob(uploadedStringImage);
      formData.append('post[image]', imgBlob, 'image.png');
      if (pollOptions.length > 0) {
        formData.append('post[poll_options]', pollOptions);
      }
    }
    if (loc) {
      formData.append('post[location][]', loc[0]);
      formData.append('post[location][]', loc[1]);
    }
    reqData.body = formData;
    try {
      this.setState({showSpinner: true});
      const d = await fetch(reqData.uri, reqData);
      if (d.status == 429) {
        console.log('Error: ' + d.status);
        return;
      }
      d.json().then(data => {
        if (data) {
          let jsonBody = data;
          let newPost = jsonBody['posts'];
          newPost.user = that.props.user;
          if (that.props.timeline) {
            let posts = that.props.timeline.state.posts;
            posts.unshift(newPost);
            that.props.timeline.setState({posts: posts});
          } else if (that.props.messageViewer) {
            let messages = that.props.messageViewer.state.messages;
            messages.push(newPost);
          }
          if (jsonBody['meta'] && jsonBody['meta']['message']) {
            alert(jsonBody['meta']['message'])
          }
          that.clearState();
          if (that.props.post) {
            that.props.post.setState({editPost: false, data: newPost});
          }
        }
      });
    } catch(e) {
      console.log('Post creation error: ' + e);
    }
  }

  clearState(e) {
    if (e) e.preventDefault();
    this.setState({showSpinner: false, pcHeight: '', placeHolder: '', childVisible: '', postTitle: '', postBody: '', category: ''});
    this.imageUploader = undefined;
  }

  showLocationModal(e) {
    if (e) e.preventDefault();
    this.setState({showLocationModal: true});
  }

  setLocation(loc) {
    this.setState({loc: loc});
  }

  hideLocationModal(e) {
    if (e) e.preventDefault();
    this.setState({showLocationModal: false});
    if (this.state.loc) {
      this.setState({showMiniMap: true});
    }
  }

  render() {
    let locationModal = '';
    let miniMap = '';
    // TODO - Get rid of this antipattern... postCreator=this.. should never happen.
    if (this.state.showMiniMap) {
      miniMap = <div> <LocationMap user={this.props.user} postCreator={this} width='120px' height='120px' loc={this.state.loc.loc} /> </div>;
    }
    if (this.state.showLocationModal) {
      locationModal = <div className='greyOverlay'>
          <div className='basicModal'>
            <LocationMap user={this.props.user} postCreator={this} width='398px' height='350px' />
            <button className='verifyButton' onClick={(e) => this.hideLocationModal(e)} style={{width: '398px'}}>Selecione</button>
          </div>
        </div>;
    }
    let placeHolder = this.props.placeHolder || this.state.placeHolder || `Novidades ${this.props.user.username}?`,
        postBodyInput = <div className='postBodyInputDiv'>
          {this.state.analyzeResults && <span style={{color: this.state.analyzeResults[1]}}>{this.state.analyzeResults[0]}</span>}
          <textarea className='postBodyInputInput' rows={6} size={8}
               onChange={(e) => this.updatePostBody(e.target.value)}
               value={this.state.postBody || ''} />
          <br />
          <input type='submit' value='Post' />
        </div>, categorySelector = '', finalImageFile = undefined;
    if (this._imageUploader) {
      if (this._imageUploader.state && this._imageUploader.state.binFile && this._imageUploader.state.binFile.toDataURL) {
        finalImageFile = this._imageUploader.state.binFile.toDataURL();
      }
    } else if (this.imageUploader) {
      if (this.imageUploader.state && this.imageUploader.state.binFile && this.imageUploader.state.binFile.toDataURL) {
        finalImageFile = this.imageUploader.state.binFile.toDataURL();
      }
    }
    if (!finalImageFile && this.state.imageFile) {
      // Image URL got passed in from props.
      if (typeof(this.state.imageFile) === 'string') {
        if (this.state.imageFile.indexOf('missing.png') === -1) {
          finalImageFile = this.state.imageFile;
        }
      } else {
        finalImageFile = this.state.imageFile;
      }
    }
    if (this.state.categories) {
      let coptions = [];
      for (let i = 0; i < this.state.categories.length; i++) {
        let cat = this.state.categories[i];
        coptions.push(<option key={cat._id['$oid']} value={cat.name}>{cat.name}</option>);
      }
      categorySelector = <select defaultValue={'Geral'} className='catSelector' type='text' value={this.state.category || this.props.app.state.category}
                                 onChange={(e) => this.setCategory(e, e.target.value)}>
              {coptions}
            </select>;
    }
    let pollInputs = <div>
        Opção 1
          &nbsp;<input className='pollOptionInput' onChange={(e) => this.setPollOption(0, e.target.value)} value={this.state.pollOption0} /><br />
        Opção 2
          &nbsp;<input className='pollOptionInput' onChange={(e) => this.setPollOption(1, e.target.value)} value={this.state.pollOption1} /><br />
        Opção 3
          &nbsp;<input className='pollOptionInput' onChange={(e) => this.setPollOption(2, e.target.value)} value={this.state.pollOption2} /><br />
        Opção 4
          &nbsp;<input className='pollOptionInput' onChange={(e) => this.setPollOption(3, e.target.value)} value={this.state.pollOption3} /><br />
        Opção 5
          &nbsp;<input className='pollOptionInput' onChange={(e) => this.setPollOption(4, e.target.value)} value={this.state.pollOption4} /><br />
    </div>;
    if (this._imageUploader && !this.imageUploader) {
      this.imageUploader = this._imageUploader;
    }
    let postCreatorButtons = <div className='postSubmitButtonDiv'>
        {categorySelector}
        <input className='postCancelButton' onClick={(e) => this.clearState(e)} type='button' value='Cancelar' />
        <input className='postCameraButton' style={{width: '104px'}} onClick={(e) => this.showLocationModal(e)} type='button' value='Localização' />
        <input className='postCameraButton' style={{width: '104px'}} onClick={(e) => this.analyzePost(e)} type='button' value='Analyze' />
        <input className='postCameraButton' onClick={(e) => this.showImageUploader(e)} type='button' value='Imagem' />
        <input className='postSubmitButton' type='submit' value={this.props.title ? 'Salvar' : 'Post'} />
        { this.state.showImageUploader ? <ImageUploader finish={this.hideImageUploader.bind(this)} ref={(ref) => this._imageUploader = ref}  /> : '' }
        { finalImageFile ? <div className='postImagePreview'><img src={finalImageFile} alt='preview' width={100} /></div> : '' }
        { this.state.category === 'Votaçao' ? pollInputs : '' }
        {miniMap}
    </div>;
    return (
      <div className='postCreator'>
        <form onSubmit={(e) => this.submitPost(e)}>
          <div onClick={this.showBody.bind(this)}>
            <div className='postTitleInputDiv'>
              <img className='avatar' src={this.props.user.avatar} alt={this.props.user.username} />
              <input className='postTitleInputInput' placeholder={placeHolder} type='text' onClick={(e) => this.setState({placeHolder: 'Title'})}
                     onChange={(e) => this.updatePostTitle(e.target.value)} value={this.props.title || this.state.postTitle || ''} />
            </div>
          </div>
          { ( this.props.body || this.state.childVisible ) ? postBodyInput : '' }
          { this.state.showSpinner ? <img src={spinner} alt='' style={{'position': 'fixed', 'marginLeft': '160px'}}/> : ''}
          { (this.state.childVisible || this.props.title) ? postCreatorButtons : '' }
        </form>
        {locationModal}
      </div>
    );
  }
}
